module.exports = __webpack_public_path__ + "static/og-image-sm-03de7b0da8cc936e064f5d9928186ceb.png";